import { WidgetsSupportChatChatDetail } from '@/widgets/support-chat';

export const PagesSupportDetail = () => <WidgetsSupportChatChatDetail />;
